function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M32 16a16 16 0 1 0-18.5 15.8V20.625H9.438V16H13.5v-3.525c0-4.01 2.389-6.225 6.043-6.225a24.6 24.6 0 0 1 3.582.312V10.5h-2.018A2.312 2.312 0 0 0 18.5 13v3h4.438l-.709 4.625H18.5V31.8A16 16 0 0 0 32 16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "none",
  d: "M314.808 214.394l.71-4.631h-4.443v-3.005a2.316 2.316 0 0 1 2.611-2.5h2.02v-3.943a24.639 24.639 0 0 0-3.586-.313c-3.66 0-6.052 2.218-6.052 6.233v3.53H302v4.631h4.068v11.2a16.192 16.192 0 0 0 5.007 0v-11.2z",
  transform: "translate(-292.572 -193.784)"
});

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f31279c1.svg";
export { ForwardRef as ReactComponent };